/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Link, RouteComponentProps, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import xlsx from 'xlsx';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';
import { GetTableFooter } from '../../../_component/tableFooter';

type bookIsParam = {
  bookIs: string;
};

export function AdminListBook(props: RouteComponentProps) {
  const { match } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [categoryList, setCategory] = useState<any[]>([]);
  const [items, setItems] = useState<any[]>([]);
  const [meta, setMeta] = useState<any>({});
  const [inputStatus, setInputStatus] = useState<string>('');
  const [searchSelect, setSearchSelect] = useState<string>('all');
  const [searchText, setSearchText] = useState<string>('');
  const [excelLoading, setExcelLoading] = useState<string>('(준비중)');
  const [excelData, setExcelData] = useState<any>([
    {
      id: '',
      categoryId: '',
      name: '',
      author: '',
      price: '',
      isbn: '',
    },
  ]);
  const excelDataEmpty = [
    {
      id: '',
      categoryId: '',
      name: '',
      author: '',
      price: '',
      isbn: '',
    },
  ];
  let excelCategoryList: any[] = [];

  let { bookIs } = match.params as bookIsParam;

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    getCategoryList().then(() => {
      getBooks();
    });
    setInputStatus('');
  }, []);

  useEffect(() => {
    getCategoryList().then(() => {
      getBooks();
    });
    setInputStatus('');
  }, [currentPage]);

  const options = [
    {
      value: 'all',
      name: '전체',
    },
    {
      value: 'name',
      name: '제목',
    },
    {
      value: 'introduce',
      name: '내용',
    },
    {
      value: 'author',
      name: '저자',
    },
  ];

  // 검색 아이콘 클릭 시
  const onClickSearch = () => {
    setCurrentPage(1);
    getBooks();
  };

  // 카테고리 API 호출
  const getCategoryList = async () => {
    const itemList: any = [];
    const list = await server.getCategories();
    list.forEach((item: any) => {
      if (item.children.length !== 0) {
        item.children.forEach((child: any) => {
          itemList.push(child);
        });
      }
    });
    setCategory(itemList);
    excelCategoryList = itemList;
  };

  // 도서 리스트 API 호출
  const getBooks = async () => {
    if (bookIs === 'isMain' && searchText === '') {
      bookIs = 'Y';
      await server
        .getBookIs(currentPage, 10, bookIs, '', '', '', '', '')
        .then(async (payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            bookIs = 'isMain';
            setItems(payload.items);
            setMeta(payload.meta);
            await server
              .getBookIs(1, payload.meta.totalItems, 'Y', '', '', '', '', '')
              .then((payload2) => {
                if (payload2.items.length !== 0) {
                  dataExcelInput(payload2);
                } else {
                  setExcelData(excelDataEmpty);
                }
              })
              .catch((error) => {
                dispatch(
                  toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                );
                console.log(error);
              });
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
    if (bookIs === 'isBest' && searchText === '') {
      bookIs = 'Y';
      await server
        .getBookIs(currentPage, 10, '', bookIs, '', '', '', '')
        .then(async (payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            bookIs = 'isBest';
            setItems(payload.items);
            setMeta(payload.meta);
            await server
              .getBookIs(1, payload.meta.totalItems, '', 'Y', '', '', '', '')
              .then((payload2) => {
                if (payload2.items.length !== 0) {
                  dataExcelInput(payload2);
                } else {
                  setExcelData(excelDataEmpty);
                }
              })
              .catch((error) => {
                dispatch(
                  toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                );
                console.log(error);
              });
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
    if (bookIs === 'isNew' && searchText === '') {
      bookIs = 'Y';
      await server
        .getBookIs(currentPage, 10, '', '', bookIs, '', '', '')
        .then(async (payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            bookIs = 'isNew';
            setItems(payload.items);
            setMeta(payload.meta);
            await server
              .getBookIs(1, payload.meta.totalItems, '', '', 'Y', '', '', '')
              .then((payload2) => {
                if (payload2.items.length !== 0) {
                  dataExcelInput(payload2);
                } else {
                  setExcelData(excelDataEmpty);
                }
              })
              .catch((error) => {
                dispatch(
                  toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                );
                console.log(error);
              });
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
    if (bookIs === 'isRecommendation' && searchText === '') {
      bookIs = 'Y';
      await server
        .getBookIs(currentPage, 10, '', '', '', bookIs, '', '')
        .then(async (payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            bookIs = 'isRecommendation';
            setItems(payload.items);
            setMeta(payload.meta);
            await server
              .getBookIs(1, payload.meta.totalItems, '', '', '', 'Y', '', '')
              .then((payload2) => {
                if (payload2.items.length !== 0) {
                  dataExcelInput(payload2);
                } else {
                  setExcelData(excelDataEmpty);
                }
              })
              .catch((error) => {
                dispatch(
                  toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                );
                console.log(error);
              });
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
    if (bookIs === 'isDisplay' && searchText === '') {
      bookIs = 'Y';
      await server
        .getBookIs(currentPage, 10, '', '', '', '', bookIs, '')
        .then(async (payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            bookIs = 'isDisplay';
            setItems(payload.items);
            setMeta(payload.meta);
            await server
              .getBookIs(1, payload.meta.totalItems, '', '', '', '', 'Y', '')
              .then((payload2) => {
                if (payload2.items.length !== 0) {
                  dataExcelInput(payload2);
                } else {
                  setExcelData(excelDataEmpty);
                }
              })
              .catch((error) => {
                dispatch(
                  toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                );
                console.log(error);
              });
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
    if (bookIs === 'isColor' && searchText === '') {
      bookIs = 'Y';
      await server
        .getBookIs(currentPage, 10, '', '', '', '', '', bookIs)
        .then(async (payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            bookIs = 'isColor';
            setItems(payload.items);
            setMeta(payload.meta);
            await server
              .getBookIs(1, payload.meta.totalItems, '', '', '', '', '', 'Y')
              .then((payload2) => {
                if (payload2.items.length !== 0) {
                  dataExcelInput(payload2);
                } else {
                  setExcelData(excelDataEmpty);
                }
              })
              .catch((error) => {
                dispatch(
                  toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                );
                console.log(error);
              });
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
    if (bookIs === 'all') {
      getCategoryList();
      if (searchText.length === 0) {
        await server
          .getBooks(currentPage, 10)
          .then(async (payload) => {
            if (!payload) {
              dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
            } else if (payload.code === 260 || payload.code === 500) {
              dispatch(toast.error({ message: '파라미터 오류' }));
            } else {
              setItems(payload.items);
              setMeta(payload.meta);
              await server
                .getBooks(1, payload.meta.totalItems)
                .then((payload2) => {
                  if (payload2.items.length !== 0) {
                    dataExcelInput(payload2);
                  } else {
                    setExcelData(excelDataEmpty);
                  }
                })
                .catch((error) => {
                  dispatch(
                    toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                  );
                  console.log(error);
                });
            }
          })
          .catch((error) => {
            dispatch(
              toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
            );
            console.log(error);
          });
      } else {
        switch (searchSelect) {
          case 'all':
            getCategoryList();
            await server
              .searchBooks(currentPage, 10, '', '', '', searchText)
              .then(async (payload) => {
                setItems(payload.items);
                setMeta(payload.meta);
                await server
                  .searchBooks(1, payload.meta.totalItems, '', '', '', searchText)
                  .then((payload2) => {
                    if (payload2.items.length !== 0) {
                      dataExcelInput(payload2);
                    } else {
                      setExcelData(excelDataEmpty);
                    }
                  })
                  .catch((error) => {
                    dispatch(
                      toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                    );
                    console.log(error);
                  });
              })
              .catch((error) => {
                console.log('검색 실패', error);
              });
            break;
          case 'name':
            getCategoryList();
            await server
              .searchBooks(currentPage, 10, searchText, '', '', '')
              .then(async (payload) => {
                setItems(payload.items);
                setMeta(payload.meta);
                await server
                  .searchBooks(1, payload.meta.totalItems, searchText, '', '', '')
                  .then((payload2) => {
                    if (payload2.items.length !== 0) {
                      dataExcelInput(payload2);
                    } else {
                      setExcelData(excelDataEmpty);
                    }
                  })
                  .catch((error) => {
                    dispatch(
                      toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                    );
                    console.log(error);
                  });
              })
              .catch((error) => {
                console.log('검색 실패', error);
              });
            break;
          case 'introduce':
            getCategoryList();
            await server
              .searchBooks(currentPage, 10, '', searchText, '', '')
              .then(async (payload) => {
                setItems(payload.items);
                setMeta(payload.meta);
                await server
                  .searchBooks(1, payload.meta.totalItems, '', searchText, '', '')
                  .then((payload2) => {
                    if (payload2.items.length !== 0) {
                      dataExcelInput(payload2);
                    } else {
                      setExcelData(excelDataEmpty);
                    }
                  })
                  .catch((error) => {
                    dispatch(
                      toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                    );
                    console.log(error);
                  });
              })
              .catch((error) => {
                console.log('검색 실패', error);
              });
            break;
          case 'author':
            getCategoryList();
            await server
              .searchBooks(currentPage, 10, '', '', searchText, '')
              .then(async (payload) => {
                setItems(payload.items);
                setMeta(payload.meta);
                await server
                  .searchBooks(1, payload.meta.totalItems, '', '', searchText, '')
                  .then((payload2) => {
                    if (payload2.items.length !== 0) {
                      dataExcelInput(payload2);
                    } else {
                      setExcelData(excelDataEmpty);
                    }
                  })
                  .catch((error) => {
                    dispatch(
                      toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                    );
                    console.log(error);
                  });
              })
              .catch((error) => {
                console.log('검색 실패', error);
              });
            break;
          default:
            break;
        }
      }
    }
  };

  // 엑셀에 데이터값 넣기
  const dataExcelInput = async (data: any) => {
    const dataArray = [];
    for (let i = 0; data.items.length > i; i++) {
      dataArray[i] = {
        id: data.items[i].id,
        categoryId: getExcelCategoryName(data.items[i].categoryId),
        name: data.items[i].name,
        author: data.items[i].author,
        price: data.items[i].price,
        isbn: data.items[i].isbn,
      };
    }
    setExcelData(dataArray);
    setExcelLoading('(준비완료)');
  };

  // 라디오 버튼 클릭 시
  const handleClickRadioBtn = (radioBtnName: string) => {
    setInputStatus(radioBtnName);
  };

  // 카테고리 코드를 카테고리명으로 찾아서 변경 (테이블용)
  const getCategoryName = (id: string) => {
    const category = categoryList.find((categoryItem: any) => categoryItem.id === id);
    if (category) {
      return category.name;
    }
    return '';
  };

  // 카테고리 코드를 카테고리명으로 찾아서 변경 (엑셀용)
  const getExcelCategoryName = (id: string) => {
    const category = excelCategoryList.find((categoryItem: any) => categoryItem.id === id);
    if (category) {
      return category.name;
    }
    return '';
  };

  // 특정 도서 클릭 시 (도서 수정페이지 진입)
  const onClickData = (bookId: any) => {
    props.history.push({
      pathname: `/admin/book/detail/${bookId}`,
      state: { update: true },
    });
  };

  // 엑셀 저장하기 버튼 클릭 시
  const onClickExcel = () => {
    const ws = xlsx.utils.json_to_sheet(excelData);
    const wb = xlsx.utils.book_new();
    ['번호', '분류', '도서명', '저자', '단가', 'ISBN'].forEach((x, idx) => {
      const cellAdd = xlsx.utils.encode_cell({ c: idx, r: 0 });
      ws[cellAdd].v = x;
    });
    xlsx.utils.book_append_sheet(wb, ws, 'sheet1');
    xlsx.writeFile(wb, 'books.xlsx');
  };

  // 삭제 버튼 클릭 시
  const onClickDelete = async () => {
    if (inputStatus !== '') {
      if (window.confirm('정말 삭제하시겠습니까?')) {
        await server
          .deleteBook(inputStatus)
          .then(() => {
            getBooks();
            dispatch(toast.info({ message: '선택된 항목이 삭제되었습니다.' }));
            setInputStatus('');
          })
          .catch((error) => {
            dispatch(
              toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
            );
            console.log(error);
          });
      }
    } else {
      dispatch(toast.error({ message: '선택된 항목이 없습니다.' }));
    }
  };

  // AdminListBook 리턴값
  return (
    <main className="wrapper list">
      <div className="title">
        <h1>도서 조회 및 수정</h1>
        {bookIs === 'all' ? (
          <div className="buttons">
            <button type="button" onClick={onClickExcel}>
              엑셀파일로 저장 {excelLoading}
            </button>
          </div>
        ) : (
          <div className="buttons">
            <button
              type="button"
              onClick={() => {
                bookIs = 'all';
                props.history.push({ pathname: `/admin/book/list/${bookIs}` });
                getBooks();
              }}
            >
              도서 전체보기
            </button>
          </div>
        )}
      </div>
      <div className="content">
        <div className="table-header">
          <div className="total">
            {bookIs === 'isMain' ? <span>메인도서 </span> : <span />}
            {bookIs === 'isBest' ? <span>BEST도서 </span> : <span />}
            {bookIs === 'isNew' ? <span>신간도서 </span> : <span />}
            {bookIs === 'isRecommendation' ? <span>추천도서 </span> : <span />}
            {bookIs === 'isDisplay' ? <span>전시도서 </span> : <span />}
            {bookIs === 'isColor' ? <span>컬러도서 </span> : <span />}
            <span>총 </span>
            <span>{meta?.totalItems} 권</span>
          </div>
          {bookIs === 'all' ? (
            <div className="search">
              <div className="selectbox">
                <select
                  name=""
                  id=""
                  onChange={(event) => {
                    setSearchSelect(event.target.value);
                  }}
                >
                  {options.map((it) => (
                    <option value={it.value} key={it.value}>
                      {it.name}
                    </option>
                  ))}
                </select>
              </div>
              <input
                type="search"
                value={searchText}
                onChange={(dom) => {
                  setSearchText(dom.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setCurrentPage(1);
                    getBooks();
                  }
                }}
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                onClick={onClickSearch}
              >
                <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
              </svg>
            </div>
          ) : (
            <div className="buttons">
              <button type="button" onClick={onClickExcel}>
                엑셀파일 {excelLoading}
              </button>
            </div>
          )}
        </div>

        <div className="table">
          <ul className="row title">
            <li className="check"> </li>
            <li className="counter">번호</li>
            <li className="categories">
              <span>대분류</span>
              <span>소분류</span>
            </li>
            <li className="book-title">도서명</li>
            <li>저자</li>
            <li className="price">단가</li>
            <li className="quantity">수량</li>
          </ul>
          {items?.map((item: any) => (
            <ul className="row" key={item.id}>
              <li className="check">
                <div className="checkbox">
                  <input
                    id={item.id}
                    type="checkbox"
                    checked={inputStatus === item.id}
                    onChange={() => handleClickRadioBtn(item.id)}
                  />
                  <label htmlFor={item.id} />
                </div>
              </li>
              <li className="counter">{item.id}</li>
              <li className="categories">
                <span>{getCategoryName(item.categoryId)}</span>
              </li>
              <li className="book-title" onClick={() => onClickData(item.id)}>
                {item.name}
              </li>
              <li className="author">{item.author}</li>
              <li className="price">{Number(item.price).toLocaleString()}</li>
              <li className="quantity">{Number(item.qty).toLocaleString()}</li>
            </ul>
          ))}
        </div>
        {GetTableFooter(
          meta?.currentPage,
          meta?.totalPages,
          (page: number) => setCurrentPage(page),
          '삭제',
          onClickDelete,
          true
        )}
      </div>
    </main>
  );
}
